// Copyright (c) Docugami, Inc. All rights reserved.

export enum OAuthRequestStatus {
    None = 'None',
    Initiated = 'Initiated',
    Authorizing = 'Authorizing',
    Succeeded = 'Succeeded',
    Failed = 'Failed',
    Timeout = 'Timeout'
}

export interface UserAuthRequest {
    id: string;
    address: string;
}

export interface TokenResponse {
    request?: UserAuthRequest;
    accessToken?: Token;
}

export interface Token {
    value: string;
    expirationSeconds: number;
    createdAt: Date;
}
